import { Box, Typography, List, ListItem } from '@mui/material'

export default function DeviceCheckResults({ devices }) {
  return (
    <Box>
      {Object.entries(devices).map(([deviceType, deviceList], idx) => (
        <Box key={idx} mt={2}>
          <Typography variant="h5">{deviceType}</Typography>
          <List>
            {deviceList && deviceList.length > 0 ? (
              deviceList.map((device, i) => (
                <ListItem key={i}>
                  <Box
                    p={3}
                    border={1}
                    borderColor="grey.300"
                    borderRadius={2}
                    mb={1}
                  >
                    ID: <strong>{device.id || 'None'}</strong> - Eligible:{' '}
                    <strong>{device.is_eligible ? 'YES' : 'NO'}</strong>
                    <List>
                      {device.requirements_result.map((req, j) => (
                        <ListItem key={j}>
                          {req.name} -{' '}
                          <strong>
                            {req.is_eligible
                              ? ' MEETS!'
                              : ' NO! - ' + req.ineligible_reasons.join(', ')}
                          </strong>
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                </ListItem>
              ))
            ) : (
              <ListItem>
                Not allowed in program! (or no devices to check)
              </ListItem>
            )}
          </List>
        </Box>
      ))}
    </Box>
  )
}
